import { render, staticRenderFns } from "./MessageDriverDialog.vue?vue&type=template&id=27351675&scoped=true&"
import script from "./MessageDriverDialog.vue?vue&type=script&lang=js&"
export * from "./MessageDriverDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27351675",
  null
  
)

export default component.exports